import React from "react";

interface SubmenuChevronProps {
  isOpen?: boolean;
  className?: string;
}

// Mobile-only affordance on submenu rows. Points right while a row is
// collapsed (or when the row is a plain link) and rotates down once it opens.
const SubmenuChevron: React.FC<SubmenuChevronProps> = ({
  isOpen = false,
  className = "",
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={`shrink-0 transition-transform duration-300 ease-in-out ${
      isOpen ? "rotate-90" : ""
    } ${className}`}
  >
    <path
      d="M6 2.72021L10.3467 7.06688C10.86 7.58022 10.86 8.42021 10.3467 8.93355L6 13.2802"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SubmenuChevron;
